import { CatalogTransferDecision, CatalogTransferView } from '@Entities/rightsholder/catalog-transfer-view'

export const getCatalogTransferDecisionForMember = (
    transfer: CatalogTransferView | undefined,
    memberId: number | undefined
): CatalogTransferDecision | undefined => {
    const decisions = transfer?.decisions
    if (!decisions?.length || memberId == null) {
        return undefined
    }

    if (decisions.some((decision) => decision.memberId !== memberId)) {
        throw new Error('Catalog transfer decision memberId does not match current rightsholder.')
    }

    return decisions[0]
}

export const isCatalogTransferDecisionFinal = (decision: CatalogTransferDecision | undefined): boolean =>
    decision?.status === 'APPROVE' || decision?.status === 'DENY'

export const getCatalogTransferDecisionLabel = (decision: CatalogTransferDecision | undefined): string | undefined => {
    if (!decision) {
        return undefined
    }
    switch (decision.status) {
        case 'APPROVE':
            return 'Transfer Approved'
        case 'DENY':
            return 'Transfer Denied'
        case 'PENDING':
        default:
            return 'Awaiting Your Decision'
    }
}
